
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Depuis plus d'un an, les candidats au vaccin contre le Covid se sont multipliés.
Plusieurs ont franchi la ligne d'arrivée. Selon un décompte du "New York Times",
plus de 100 produits font l'objet d'essais cliniques sur des humains, dont une
vingtaine ont été autorisés quelque part dans le monde, que ce soit pour un
usage d'urgence ou de façon complète. Entre grandes surprises et déceptions,
tous ces produits ne connaissent toutefois pas le même destin.`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.bag.admin.ch/bag/fr/home/krankheiten/ausbrueche-epidemien-pandemien/aktuelle-ausbrueche-epidemien/novel-cov/impfen.html#-872895573"
      }}>{`Trois vaccins sont autorisés et distribués en Suisse`}</a>{`
(Pfizer/BioNTech, Moderna et Janssen). Des commandes ont aussi été passées
auprès d'AstraZeneca, Curevac et Novavax, sans qu'on sache exactement quel rôle
ces produits vont jouer. Tous ces noms semblent compliqués? Le point sur les
principaux vaccins, leurs avantages et leurs inconvénients.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;